import { filters } from '../NTContext';
import { cellStates } from '../NTSelectionContext';
import { actions, AccountVisualFiltersProps } from '../NTUtilsContext';
import { TableFilters, TableActions, TableSelection } from '../types';

export const readURLParams = (): {
  filter: TableFilters;
  actions: TableActions;
  accountVFilters: AccountVisualFiltersProps;
  selection: TableSelection & { columnID: string | null };
  urlBudgetInclude: boolean;
} => {
  const urlParams = new URLSearchParams(window.location.search);
  const filter = {
    percentage: urlParams.get('percentage') !== 'false',
    money: urlParams.get('money') !== 'false',
    actuals: urlParams.get('actuals') !== 'false',
    transactions: urlParams.get('transactions') !== 'false',
    smoothing: urlParams.get('smoothing') === 'true',
    budget: urlParams.get('budget') !== 'false',
    variance: urlParams.get('variance') === 'true',
    anomalies: urlParams.get('anomalies') === 'true',
  };

  const isExpandedParam = urlParams.get('rightPanelExpanded') === '1';

  // Note: reverseColumns removed - backend handles via URL parameter
  const actions = {
    detailsPanel: urlParams.get('detailsPanel') === 'true' || isExpandedParam,
    difference: urlParams.get('difference') === 'true',
    total: urlParams.get('total') === 'true',
  };

  const selection = {
    rowID: urlParams.get('rowID') || null,
    columnID: urlParams.get('columnID') || null,
  };

  if (!filter.budget && !filter.actuals) {
    filter.actuals = true;
  }

  if (!filter.percentage && !filter.money) {
    filter.money = true;
  }

  const accountVFilters = {
    accounts: urlParams.get('accounts') === 'true',
    percentageLegend: urlParams.get('percentageLegend') !== 'false',
    sparklines: urlParams.get('sparklines') !== 'false',
  };

  const urlBudgetInclude = urlParams.get('budget') === 'true';
  if (urlBudgetInclude) {
    filter.budget = urlBudgetInclude;
  }
  //console.log('filter from URL', window.location.search, filter, actions, selection);
  return { filter, actions, selection, urlBudgetInclude, accountVFilters };
};

export const saveURLParams = ({
  filters,
  actions,
  cellState,
  accountVisualFilters,
  budgetAvailable,
}: {
  filters: filters;
  actions: actions;
  cellState: cellStates;
  accountVisualFilters: AccountVisualFiltersProps;
  budgetAvailable?: boolean;
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  Object.entries(filters).forEach(([key, value]) => {
    if (key === 'money') {
      urlParams.set('amounts', value.toString());
    }
    // Don't write budget-related params to URL if report has no budget data
    if (!budgetAvailable && (key === 'budget' || key === 'variance')) {
      urlParams.delete(key);
      return;
    }
    urlParams.set(key, value.toString());
  });

  // Note: reverseColumns removed - backend handles via URL parameter
  const allowedActions = ['total', 'difference', 'detailsPanel'];
  Object.entries(actions).forEach(([key, value]) => {
    if (allowedActions.includes(key)) {
      urlParams.set(key, value.toString());
    }
  });

  Object.entries(accountVisualFilters).forEach(([key, value]) => {
    urlParams.set(key, value.toString());
  });

  if (cellState.selected) urlParams.set('rowID', cellState.selected);
  if (cellState.selectedColumn !== undefined && cellState.selectedColumn !== null) {
    urlParams.set('columnID', cellState.selectedColumn.toString());
  }

  window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
  //console.log('Writting URL', urlParams.toString(), filters, actions, accountVisualFilters);
};
